import React, { useContext, useEffect, useState } from 'react';
import AuthContext from './auth/AuthContext';
import { SButton, SIconButton, SInputLabel, STitleContainer, STitleH3 } from './common/BCommonComponents';
import { Button, FormControl, Grid, MenuItem, Select } from '@material-ui/core';
import { createStyles, makeStyles, Theme } from '@material-ui/core/styles';
import { toast } from 'react-toastify';
import { PuntoServizioDTO, UserRole } from './common/Dtos';
import { getLastFiveYears } from './common/DateUtils';
import { FaTimes } from 'react-icons/all';

export function Upload() {
	const auth = useContext(AuthContext);
	const useStyles = makeStyles((theme) => ({

		root: {
			'& > *': {
				margin: theme.spacing(1),
			},
		},
		input: {
			display: 'none',
		},
	}));

	const useStylesFormControl = makeStyles((theme: Theme) =>
		createStyles({
			formControl: {
				// margin: theme.spacing(1),
				width: '100%',
			},
			selectEmpty: {
				width: '100%',
				margin: '0',
			},
		}),
	);

	const formControlClasses = useStylesFormControl();

	const classes = useStyles();
	const [file, setFile] = useState<Blob | null>(null);
	const [fileName, setFileName] = useState<String>();
	const [puntiServizioList, setPuntiServizioList] = useState<PuntoServizioDTO[]>([]);
	const [puntoServizioSelected, setPuntoServizioSelected] = useState<string>('');
	const [yearsList, setYearsList] = useState<number[]>([]);
	const [yearSelected, setYearSelected] = useState<string>('');
	const [errorPs, setErrorPs] = useState<boolean>(false);
	const [errorAnno, setErrorAnno] = useState<boolean>(false);
	const [errorFile, setErrorFile] = useState<boolean>(false);

	useEffect(() => {
		getPuntiServizio();
		let years = getLastFiveYears();
		setYearsList(years);
	}, [])

	const getPuntiServizio = () => {
		if (auth.state.roles && auth.state.roles.indexOf(UserRole.OPERATOR) > -1) {
			auth.state.axiosInstance?.get('/api/puntoServizio/punti_servizio_of_operatore/' + auth.state.id)
				.then(res => {
					setPuntiServizioList(res.data);
				}).catch(error => {
				toast.error('🛑 Errore durante il recupero dei Punti di Servizio!');
				console.log(error);
			});
		} else {
			auth.state.axiosInstance?.get('/api/puntoServizio/punto_servizio_by_cooperativa/' + auth.state.cooperativa + '?login=' + false)
				.then(res => {
					setPuntiServizioList(res.data)
				})
				.catch(error => {
					toast.error('🛑 Errore durante il recupero dei Punti di Servizio!');
					console.log(error);
				})
		}

	}

	const handleFileChange = (event: any) => {
		setFile(event.target.files[0]);
		if (event.target.files[0]) {
			setFileName(event.target.files[0].name);
		}

		if (event.target.files[0].name !== null && event.target.files[0].name !== undefined) {
			setErrorFile(false);
		}

		event.target.value = null;
	}

	const handlePuntoServizioChange = (event: React.ChangeEvent<{ value: unknown }>) => {
		const ps = event.target.value as string;
		setPuntoServizioSelected(ps);
	};

	const handleAnnoChange = (event: React.ChangeEvent<{ value: unknown }>) => {
		const anno = event.target.value as string;
		setYearSelected(anno);
	};

	const handleDeleteFile = () => {
		setFile(null);
		setFileName('');
	}

	const handleUploadFile = () => {
		if (!puntoServizioSelected || puntoServizioSelected === '' || yearSelected === '' || file == undefined || file === null) {
			setErrorAnno(yearSelected === '');
			setErrorPs(!puntoServizioSelected || puntoServizioSelected === '');
			setErrorFile(!file);
		} else {
			setErrorAnno(false);
			setErrorPs(false);
			setErrorFile(false);
			let formData = new FormData();

			formData.append("file", file);
			formData.append("anno", yearSelected);
			formData.append("puntoServizio", puntoServizioSelected);
			formData.append("cooperativa", auth.state.cooperativa ? auth.state.cooperativa : '');
			auth.state.axiosInstance?.post('/api/pg/prestazione/upload', formData)
				.then(res => {
					if (res.data === "not-import") {
						toast.warning('Nessuna prestazione caricata. File importato in precedenza.');
					} else {
						toast.success(res.data);
					}
					// event.target.value = null;
				})
				.catch(error => {
					toast.error('🛑 Errore durante l\'import!');
					console.log(error);
					// event.target.value = null;
				});
		}
	}

	const labelStyle = {
		marginBottom: "0 !important"
	};

	return (
		<div>
			<STitleContainer>
				<STitleH3>Import Call Center</STitleH3>
			</STitleContainer>
			<Grid container spacing={0} className="w-100 my-4 align-items-center">
				<input
					accept=".xls, .xlsx"
					id="contained-button-file"
					className={classes.input}
					type="file"
					onChange={handleFileChange}
				/>
				<label htmlFor="contained-button-file" style={labelStyle}>
					<Button className="btn-upload" variant="contained" component="span">
						Seleziona File
					</Button>
				</label>
				{fileName &&
					<React.Fragment>
						<p className="d-flex align-items-center ml-3 my-0">File selezionato: {fileName}</p>
						<SIconButton onClick={handleDeleteFile} variant="rosso" size="small" className="mx-2 my-0"><FaTimes className="mx-1"/></SIconButton>
					</React.Fragment>
				}
				{errorFile &&
				<p className="d-flex align-items-center ml-3 my-0 text-danger">Seleziona un file</p>}
			</Grid>
			<Grid container spacing={0} className="w-100 my-4">
				<Grid item xs={3} className="pr-2">
					<FormControl variant="outlined" className={formControlClasses.formControl} required={true} error={errorPs}>
						<SInputLabel id="puntoServizio">Punto di Servizio</SInputLabel>
						<Select
							required
							labelId="puntoServizio"
							id="puntoServizioSelect"
							className={formControlClasses.selectEmpty}
							label="Punto di Servizio"
							value={puntoServizioSelected}
							onChange={handlePuntoServizioChange}
							MenuProps={{
								anchorOrigin: {
									vertical: "bottom",
									horizontal: "left"
								},
								transformOrigin: {
									vertical: "top",
									horizontal: "left"
								},
								getContentAnchorEl: null
							}}
						>
							{puntiServizioList && puntiServizioList.map(op => {
								return (
									<MenuItem value={op.id} key={op.id}>{op.name}</MenuItem>
								)
							})}
						</Select>
					</FormControl>
				</Grid>
				<Grid item xs={3} className="pr-2">
					<FormControl variant="outlined" className={formControlClasses.formControl} required={true} error={errorAnno}>
						<SInputLabel id="puntoServizio">Anno di riferimento</SInputLabel>
						<Select
							required
							labelId="annoRiferimento"
							id="annoRiferimentoSelect"
							className={formControlClasses.selectEmpty}
							label="Anno di riferimento"
							value={yearSelected}
							onChange={handleAnnoChange}
							MenuProps={{
								anchorOrigin: {
									vertical: "bottom",
									horizontal: "left"
								},
								transformOrigin: {
									vertical: "top",
									horizontal: "left"
								},
								getContentAnchorEl: null
							}}
						>
							{yearsList && yearsList.map(year => {
								return (
									<MenuItem value={year} key={year}>{year.toString()}</MenuItem>
								)
							})}
						</Select>
					</FormControl>
				</Grid>
				<Grid item xs={3} className="pr-2">
					<SButton onClick={handleUploadFile} className="mt-2">Carica</SButton>
				</Grid>
			</Grid>
		</div>
	)
}
